import React, { useState } from 'react'
import { DatePicker, TextInput } from '@tecuity/granite-ui'
import { format } from 'date-fns'
import IconCalendar from '@tecuity/sos-icons/react/calendar'
import './DateRow.scss'

const DateRow = ({ rowLabel, date, setDate, disabled, showTodayButton, maxDate, minDate }) => {
  const [showDatePicker, setShowDatePicker] = useState(false)

  return (
    <div className="date-row-wrapper">
      <TextInput
        aria-label={`${rowLabel} String Input`}
        placeholder="MM/DD/YYYY"
        onChange={(e) => {
          setDate(e.target.value)
        }}
        value={date}
        disabled={disabled}
        customCss={{ flexGrow: '1' }}
      />
      {showTodayButton && (
        <button
          className={`btn btn-primary btn-raised picker-button`}
          style={{ minWidth: 'fit-content', padding: '0px 7px' }}
          aria-label={`Select Todays Date`}
          onClick={() => {
            setDate(format(new Date(), 'MM/dd/yyyy'))
          }}
          disabled={disabled}
        >
          Today
        </button>
      )}
      <button
        className={`btn btn-primary btn-raised picker-button `}
        style={{ padding: '0px 7px' }}
        title={`Open calendar widget for ${rowLabel || 'date'}`}
        aria-label={`Open calendar widget for ${rowLabel || 'date'}`}
        onClick={() => {
          setShowDatePicker(true)
        }}
        disabled={disabled}
      >
        <IconCalendar
          style={
            disabled
              ? { backgroundColor: '#999999', width: '30px', height: '30px' }
              : { width: '30px', height: '30px' }
          }
        />
      </button>
      <DatePicker
        onChange={(e) => {
          setDate(format(new Date(e), 'MM/dd/yyyy'))
        }}
        isOpen={showDatePicker}
        disabled={disabled}
        onCalendarClose={() => setShowDatePicker(false)}
        maxDate={maxDate}
        minDate={minDate}
      />
    </div>
  )
}

export default DateRow
